export const feedbackType = {
    CASING_FORMATTING: 0,
    INCORRECT_VALUE: 1,
    GAP: 2,
    SUGGESTION: 3,
};

export const hasFeedbackTypeSelected = (value) => value !== null && value !== undefined && value !== "";

export const feedbackTypeOptions = [
    { value: feedbackType.CASING_FORMATTING, label: "Case/Formatting" },
    { value: feedbackType.INCORRECT_VALUE, label: "Incorrect Value" },
    { value: feedbackType.GAP, label: "Gap" },
    { value: feedbackType.SUGGESTION, label: "Suggestion" },
];

export const FEEDBACK_TEXT_MAX_LENGTH = 500;

export const FEEDBACK_DISCLAIMER =
    "Case, Formatting, Incorrect Values, and Gaps will automatically be reported. Only use this selection to provide clarifying information if required.";

export const FEEDBACK_SAVED_MESSAGE =
    "Thank you for your feedback! Your feedback has been saved and has been submitted to the automated attribution service.";

export const feedbackSourcePages = ["coding", "profiling"];

export const attributeFeedbackQueryKey = "attributeFeedback";
